
        <div class="form-group product__option"  >
            <div class="flex flex-col sm:flex-row form-group" >
                <label for="appt">Select a time:</label>
                <input type="time" min="09:00" max="18:00" required>
                <label for="appt">Select a time:</label>
                <input type="time" min="09:00" max="18:00" required>
            </div>

            <app-clock-timeRange-picker></app-clock-timeRange-picker>
        </div>
